import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../urunDiv.css';
import kofteWrap from '../../assets/menu/yemekler/wraplar/kofte-wrap.jpg';
import tavukluWrap from '../../assets/menu/yemekler/wraplar/tavuklu-wrap.jpg';

const Wraplar = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const wraplar = [
    { id: 1, name: 'Köfte Wrap', price: '₺599,90', image: kofteWrap },
    { id: 2, name: 'Tavuklu Wrap', price: '₺519,90', image: tavukluWrap },
  ];

  const handleClick = (item) => {
    if (item.name === 'Köfte Wrap') navigate('/wraplar/kofte-wrap');
    else if (item.name === 'Tavuklu Wrap') navigate('/wraplar/tavuklu-wrap');
  };

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Wraplar</h2>
        </div>
        <hr style={{color: '#D8D8D8'}} />
        <div className="urun-grid">
          {wraplar.map((item) => (
            <div key={item.id} className="urun-kart" onClick={() => handleClick(item)} style={{ cursor: 'pointer' }}>
              <div className="urun-bilgi">
                <h3 className="urun-ad">{item.name}</h3>
                <div className="urun-fiyat">{item.price}</div>
              </div>
              <div className="urun-resim">
                <img src={item.image} alt={item.name} style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover',
                  borderRadius: '100px',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Wraplar</h2>
        </div>
        <hr style={{color: '#D8D8D8'}} />
        <div className="urun-grid-computer">
          {wraplar.map((item) => (
            <div key={item.id} className="urun-kart-computer" onClick={() => handleClick(item)} style={{ cursor: 'pointer' }}>
              <div className="urun-bilgi">
                <h3 className="urun-ad-computer">{item.name}</h3>
                <div className="urun-fiyat-computer">{item.price}</div>
              </div>
              <div className="urun-resim">
                <img src={item.image} alt={item.name} style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '100px',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default Wraplar;
